import {collection, field} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";
import {SurchargeReportSelectionData} from "../../../pricing/surcharge/controls/surcharge-report-selection-control.component";
import {
    EntityGroupByReportCriteriaComponent
} from "../../../reports/common-report-criteria/entity-group-by-report-criteria/entity-group-by-report-criteria.component";


export class SurchargeAuditReportData extends ReportData<SurchargeAuditReportData> {
    @field reportType: string = EntityGroupByReportCriteriaComponent.SURCHARGE_VALUE;
    @collection() groupBy: string[] = ["none"];
    @field summary: boolean = true;
    @collection(SurchargeReportSelectionData) surcharges: SurchargeReportSelectionData[];
}
